<div class="sub-header">
  <div class="container" style="height: 60px;">
    <div class="controls-panel">
      <div class="header">
        <h1>
          Statistics for <span *ngIf="statistics && !loading">{{statistics.THIS_WEEK_BEG}} - {{statistics.THIS_WEEK_END
            }} </span> </h1>
      </div>

      <div class="actions">

        <button class="btn btn-rbv pull-right" (click)="onPrevious()">
          <fa name="fa fa-chevron-left"></fa> Previous Week
        </button>

        <button *ngIf="offset < 0" class="btn btn-rbv pull-right" (click)="onNext()">
          Next Week <fa name="fa fa-chevron-right"></fa>
        </button>

        <button class="btn btn-rbv pull-right" (click)="refresh()">
          <fa name="fa fa-refresh"></fa> Refresh
        </button>
      </div>

    </div>
  </div>
</div>

<div class="container">

  <loader [loading]="loading"></loader>

  <div class="wrapper" *ngIf="statistics && !loading">

    <!-- ENGAGED THIS WEEK AND LAST WEEK SECTION BEGINS -->
    <div class="row mt-5">
      <div class="col-md-5">
        <div class="content hinted top-section this_week " (click)="goToEngageView($event, true)">
          <div class="header">
            <div class="hint">Click to View Reports</div>
            <div class="label text-center">
              Engaged <span class="week this">this week</span>
            </div>

            <div *ngIf="isValidNumber(getEngagedPercentage())" class="percentage"
              [ngClass]="{'up': getEngagedPercentage() > 0, 'down': getEngagedPercentage() < 0 }">
              <i class="fa"
                [ngClass]="{'fa-arrow-up': getEngagedPercentage() > 0, 'fa-arrow-down': getEngagedPercentage() < 0 }"
                aria-hidden="true"></i>
              {{getAbsValue(getEngagedPercentage()) | percent: '2.2-5'}}
            </div>

            <button class="btn btn-rbv pull-right" (click)="onEditGoal($event)" [disabled]="checkGoal()"
              *ngIf="isEditorAccess()">
              <fa *ngIf="editGoalLabel == 'Edit'" name="fa fa-edit"></fa>
              <fa *ngIf="editGoalLabel != 'Edit'" name="fa fa-save"></fa> {{editGoalLabel}}
            </button>
          </div>

          <div class="body">
            <!-- Reports -->
            <div class="text-wrapper">
              <div *ngIf="editGoalLabel != 'Edit'">
                <input type="number" name="reports" #REPORTS="ngModel" [(ngModel)]="newGoal.GOAL_REPORTS"
                  [ngClass]="{ 'is-invalid': REPORTS.invalid }" class="rbv-field form-control rounded-0" required>
                <label>Reports</label>
              </div>

              <custom-chart *ngIf="editGoalLabel == 'Edit'" [goalValue]="statistics.GOAL_THIS_WEEK?.GOAL_REPORTS"
                [achievedValue]="statistics.ENGAGED_THIS_WEEK?.COUNT" title="Reports"></custom-chart>
            </div>

            <!-- Average -->
            <div class="text-wrapper">
              <div *ngIf="editGoalLabel != 'Edit'">
                <input type="number" name="average" #AVG="ngModel" [(ngModel)]="newGoal.GOAL_AVG"
                  [ngClass]="{ 'is-invalid': AVG.invalid }" class="rbv-field form-control rounded-0" required>
                <label>Average</label>
              </div>
              <custom-chart *ngIf="editGoalLabel == 'Edit'" [goalValue]="statistics.GOAL_THIS_WEEK?.GOAL_AVG"
                [achievedValue]="statistics.ENGAGED_THIS_WEEK?.VALUE_AVG" [isCurrency]="true" title="Average">
              </custom-chart>
            </div>

            <!-- Total -->
            <div class="text-wrapper">
              <div *ngIf="editGoalLabel != 'Edit'">
                <input type="number" name="total" #TOTAL="ngModel" [(ngModel)]="newGoal.GOAL_TOTAL"
                  [ngClass]="{ 'is-invalid': TOTAL.invalid }" class="rbv-field form-control rounded-0" required>
                <label>Total</label>
              </div>
              <custom-chart *ngIf="editGoalLabel == 'Edit'" [goalValue]="statistics.GOAL_THIS_WEEK?.GOAL_TOTAL"
                [achievedValue]="statistics.ENGAGED_THIS_WEEK?.VALUE" [isCurrency]="true" title="Total"></custom-chart>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-3">
        <div class="content hinted top-section this_week">
          <div class="header">
            <div class="label text-center">
              Engaged <span class="week this">this quarter</span>
            </div>

            <button class="btn btn-rbv pull-right" (click)="onEditGoalQuarterly($event)" [disabled]="checkQuarterGoal()"
                    *ngIf="isEditorAccess()">
              <fa *ngIf="editQuarterlyGoalLabel == 'Edit'" name="fa fa-edit"></fa>
              <fa *ngIf="editQuarterlyGoalLabel != 'Edit'" name="fa fa-save"></fa> {{editQuarterlyGoalLabel}}
            </button>
          </div>

          <div class="body d-flex justify-content-center">
            <!-- Reports -->
            <div class="text-wrapper">
              <div *ngIf="editQuarterlyGoalLabel != 'Edit'">
                <input type="number" name="quarter_total" #GOAL_REPORTS="ngModel" [(ngModel)]="quarterlyGoal.GOAL_REPORTS"
                       [ngClass]="{ 'is-invalid': GOAL_REPORTS.invalid }" class="rbv-field form-control rounded-0" required>
                <label>Total</label>
              </div>

              <custom-chart *ngIf="editQuarterlyGoalLabel == 'Edit'" [goalValue]="statistics?.GOAL_THIS_QUARTER"
                            [achievedValue]="statistics.ENGAGED_THIS_QUARTER" title="Reports"
                            achievedValueClass="text-center" goalValueClass="text-center"></custom-chart>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="content hinted top-section last_week" (click)="goToEngageView($event, false)">
          <div class="hint">Click to View Reports</div>
          <div class="header">
            <div class="label text-center">
              Engaged <span class="week last">last week</span>
            </div>
          </div>

          <div class="body">
            <!-- Reports -->
            <div class="text-wrapper">
              <custom-chart [goalValue]="statistics.GOAL_LAST_WEEK?.GOAL_REPORTS"
                [achievedValue]="statistics.ENGAGED_LAST_WEEK?.COUNT" title="Reports"></custom-chart>
            </div>

            <!-- Average -->
            <div class="text-wrapper">
              <custom-chart [goalValue]="statistics.GOAL_LAST_WEEK?.GOAL_AVG"
                [achievedValue]="statistics.ENGAGED_LAST_WEEK?.VALUE_AVG" [isCurrency]="true" title="Average">
              </custom-chart>
            </div>

            <!-- Total -->
            <div class="text-wrapper">
              <custom-chart [goalValue]="statistics.GOAL_LAST_WEEK?.GOAL_TOTAL"
                [achievedValue]="statistics.ENGAGED_LAST_WEEK?.VALUE" [isCurrency]="true" title="Total"></custom-chart>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ENGAGED THIS WEEK AND LAST WEEK SECTION END -->


    <!-- CURRENT PIPLINE AND DUES SECTION BEGINS -->
    <div class="row mt-5">
      <div class="col-md-6">
        <div class="content hinted" (click)="gotoDashboard('PENDING')">
          <div class="hint">Click to View Reports</div>
          <div class="header">
            <div class="label text-center">
              Current Pipeline
            </div>
          </div>

          <div class="body">
            <div class="text-wrapper">
              <div class="count">
                {{statistics.IN_STAGES?.COUNT}}
              </div>

              <div class="title">
                Reports
              </div>
            </div>

            <div class="text-wrapper">
              <div class="count">
                {{statistics.IN_STAGES?.VALUE | currency : 'USD' : 'symbol' : '1.0-0'}}
              </div>

              <div class="title">
                Total
              </div>
            </div>

            <div class="text-wrapper">
              <div class="count">
                {{statistics.IN_STAGES?.VALUE_AVG | currency : 'USD' : 'symbol' : '1.0-0'}}
              </div>

              <div class="title">
                Average
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="row">

          <div class="col-md-4">
            <div class="content hinted" (click)="viewReport(StatStageType.DUE_TODAY, offset)">
              <div class="hint">Click to View Reports</div>
              <div class="header">
                <div class="label text-center">
                  Due Today
                </div>
              </div>

              <div class="body center">
                <div class="text-wrapper">
                  <div class="count">
                    {{statistics.DUE_TODAY}}
                  </div>

                  <div class="title">
                    Reports
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-4">
            <div class="content hinted" (click)="viewReport(StatStageType.DUE_TOMORROW, offset)">
              <div class="hint">Click to View Reports</div>
              <div class="header">
                <div class="label text-center">
                  Due Tomorrow
                </div>
              </div>

              <div class="body center">
                <div class="text-wrapper">
                  <div class="count">
                    {{statistics.DUE_TOMORROW}}
                  </div>

                  <div class="title">
                    Reports
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-4">
            <div class="content hinted" (click)="viewReport(StatStageType.PAST_DUE, offset)">
              <div class="hint">Click to View Reports</div>
              <div class="header">
                <div class="label text-center">
                  Past Due
                </div>
              </div>

              <div class="body center">
                <div class="text-wrapper">
                  <div class="count">
                    {{statistics.PAST_DUE}}
                  </div>

                  <div class="title">
                    Reports
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- CURRENT PIPLINE AND DUES SECTION END -->


    <!-- REPORT COMPLETION AND CURRENT SECTION BEGINS -->
    <div class="row mt-5">
      <div class="col-md-6">
        <div class="content hinted">
          <div class="header">
            <div class="label text-center">
              Report Completion Time
            </div>
          </div>

          <div class="body">
            <div class="text-wrapper">
              <div class="count">
                {{statistics.COMPLETION_TIME_LAST_WEEK?.VALUE_AVG | number : '1.2-2'}}
              </div>

              <div class="title">
                Last Week
              </div>
            </div>

            <div class="text-wrapper">
              <div class="count">
                {{statistics.COMPLETION_TIME_LAST_MONTH?.VALUE_AVG | number : '1.2-2'}}
              </div>

              <div class="title">
                Last Month
              </div>
            </div>

            <div class="text-wrapper">
              <div class="count">
                {{statistics.COMPLETION_TIME_CURRENT_QUARTER?.VALUE_AVG | number : '1.2-2'}}
              </div>

              <div class="title">
                Current Quarter
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="row">
          <div class="col-md-6">
            <div class="content hinted">
              <div class="header">
                <div class="label text-center">
                  Current Quarter
                </div>
              </div>

              <div class="body center">
                <div class="text-wrapper">
                  <div class="count">
                    {{statistics.CURRENT_QUARTER}}
                  </div>

                  <div class="title">
                    Reports
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="content hinted" (click)="gotoDashboard('IN_PROCESS')">
              <div class="hint">Click to View Reports</div>
              <div class="header">
                <div class="label text-center">
                  Current Active
                </div>
              </div>

              <div class="body">
                <div class="text-wrapper">
                  <div class="count">
                    {{statistics.IN_PROCESSING}}
                  </div>

                  <div class="title">
                    Reports
                  </div>
                </div>
                <div class="text-wrapper">
                  <div class="count">
                    {{statistics.TOTAL_REVENUE | currency : 'USD' : 'symbol' : '1.0-0'}}
                  </div>

                  <div class="title">
                    Revenue
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- REPORT COMPLETION AND CURRENT SECTION END -->


    <!-- QUOTE AND ORDER AND COMPLETED SECTION BEGIN -->
    <div class="row mt-5">
      <!-- Quoted this Week -->
      <div class="col">
        <div class="content hinted">
          <div class="header font_13">
            <div class="label text-center">
              Quoted <span class="week this">this week</span>
            </div>
          </div>

          <div class="body center">
            <div class="text-wrapper">
              <div class="count">
                {{statistics.QUOTED_THIS_WEEK}}
              </div>

              <div class="title">
                Reports
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Order Received this Week -->
      <div class="col">
        <div class="content hinted">
          <div class="header text-center font_13">
            <div class="label">
              Orders Received <span class="week this">this week</span>
            </div>
          </div>

          <div class="body center">
            <div class="text-wrapper">
              <div class="count">
                {{statistics.ORDER_RECEIVED_THIS_WEEK}}
              </div>

              <div class="title">
                Reports
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Order Received last Week -->
      <div class="col">
        <div class="content hinted">
          <div class="header text-center font_13">
            <div class="label">
              Orders Received <span class="week last">last week</span>
            </div>
          </div>

          <div class="body center">
            <div class="text-wrapper">
              <div class="count">
                {{statistics.ORDER_RECEIVED_LAST_WEEK}}
              </div>

              <div class="title">
                Reports
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Completed this Week -->
      <div class="col">
        <div class="content hinted" (click)="viewReport(StatStageType.COMPLETED, offset)">
          <div class="hint">Click to View Reports</div>
          <div class="header text-center font_13">
            <div class="label">
              Completed <span class="week this">this week</span>
            </div>

            <div *ngIf="isValidNumber(getCompletedPercentage())" class="percentage"
              [ngClass]="{'up': getCompletedPercentage() > 0, 'down': getCompletedPercentage() < 0 }">
              <i class="fa"
                [ngClass]="{'fa-arrow-up': getCompletedPercentage() > 0, 'fa-arrow-down': getCompletedPercentage() < 0 }"
                aria-hidden="true"></i> {{getAbsValue(getCompletedPercentage()) | percent: '2.2-5'}}
            </div>
          </div>

          <div class="body center">
            <div class="text-wrapper">
              <div class="count">
                {{statistics.COMPLETED_THIS_WEEK}}
              </div>

              <div class="title">
                Reports
              </div>
            </div>

          </div>
        </div>
      </div>

      <!-- Completed Last Week -->
      <div class="col">
        <div class="content hinted" (click)="viewReport(StatStageType.COMPLETED, offset - 1)">
          <div class="hint">Click to View Reports</div>
          <div class="header text-center font_13">
            <div class="label">
              Completed <span class="week last">last week</span>
            </div>
          </div>

          <div class="body center">
            <div class="text-wrapper">
              <div class="count">
                {{statistics.COMPLETED_LAST_WEEK}}
              </div>

              <div class="title">
                Reports
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- QUOTE AND ORDER AND COMPLETED SECTION END -->

    <!-- Analyst Section -->

    <div class="row mt-5">
      <div class="col-md-6 mt-4">
        <div class="content hinted" (click)="viewReport(StatStageType.ANALYST_OPEN_FILES, offset - 1)">
          <div class="hint">Click to View Reports</div>
          <div class="header text-center">
            <div class="label">
               <span>Analysts' Open Files</span>
            </div>
          </div>

          <div class="body center">
            <div class="text-wrapper">
              <div class="count">
                {{statistics.ANALYST_OPEN_FILES}}
              </div>

              <div class="title">
                Reports
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6 mt-4">
        <div class="content hinted" (click)="viewReport(StatStageType.COMPLETED_REVENUE, offset)" >
          <div class="hint">Click to View Reports</div>
          <div class="header">
            <div class="label text-center">
              Weekly Completed Orders & Revenue
            </div>
          </div>

          <div class="body">
            <div class="text-wrapper">
              <div class="count">
                {{statistics.WEEKLY_COMPLETED_REVENUE?.COMPLETED_THIS_WEEK}}
              </div>

              <div class="title">
                Completed
              </div>
            </div>
            <div class="text-wrapper">
              <p>|</p>
            </div>

            <div class="text-wrapper">
              <div class="count">
                {{statistics.WEEKLY_COMPLETED_REVENUE?.REVENUE_THIS_WEEK | currency : 'USD' : 'symbol' : '1.0-0'}}
              </div>

              <div class="title">
                Revenue
              </div>
            </div>
          </div>
        </div>
      </div>


    </div>
    <!-- Analyst Section End -->

  </div>

  <!-- Statistic Chart -->
  <div class="row mt-5 pb-5 d-flex align-items-center justify-content-center">
    <loader [loading]="chartLoading"></loader>

    <div class="col-md-12" *ngIf="!chartLoading">
      <div class="chart-wrapper">
        <canvas id="historicalChart" width="1110" height="500"></canvas>
      </div>
    </div>
  </div>
</div>
